import { Box, Typography } from '@mui/material';

import NavSolicitation from './NavSolicitation';
import FadeAnimation from 'components/views/FadeAnimation';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { ReactComponent as IcIturinInterrogation } from 'assets/icons/ic-iturin-interrogation.svg';
import { ReactComponent as IcCertificateOperation } from 'assets/icons/ic-certificate-operation.svg';

import { LinkExtermal, TextDetails } from './styles';

type Params = {
    label: string;
    link: string;
    number: string;
}

const boxStyle = {
    borderRadius: '10px',
    backgroundColor: '#EFF2F5',
    padding: { xs: '1.5625rem 0 1.5rem', md: '1.625rem 4rem 1.5rem' },
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '1.125rem'
}

const LinkLabel = ({ label, link, number }: Params) => {
    return (
        <Box>
            <Typography fontSize='.9375rem' fontWeight={600}>
                {label}
            </Typography>
            <LinkExtermal href={link}>
                {number}
                <LocalPhoneOutlinedIcon />
            </LinkExtermal>
        </Box>
    )
}

const Cancellation = () => {
    return (
        <FadeAnimation>
            <Box>
                <NavSolicitation title='Cancelamento' icon={<IcCertificateOperation />} />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', maxWidth: '37.5rem', margin: '0 auto' }}>
                    <Box sx={{ width: { xs: '100%', md: 'fit-content' }, display: 'flex', alignItems: { xs: 'center', md: 'flex-end' }, flexDirection: { xs: 'column', md: 'row' }, position: 'relative' }}>
                        <TextDetails sx={{ margin: { xs: '7.5rem 0 .5rem', md: '0' } }}>
                            Que triste saber que você <br />
                            esteja considerando cancelar o <br />
                            seu serviço.
                        </TextDetails>
                        <Box sx={{ margin: { xs: '0', md: '0 -2.5rem 1.5rem' }, zIndex: '0', position: { xs: 'absolute', md: 'relative' }, top: '0' }}>
                            <IcIturinInterrogation />
                        </Box>
                        <TextDetails>
                            Sentiremos muito a sua <br />
                            falta como nosso cliente.
                        </TextDetails>
                    </Box>

                    <Typography fontSize='.93rem' padding='2.43rem 0 1.25rem' textAlign='center' margin='0 auto'>
                        <strong>Entre em contato conosco</strong> e vamos ajudá-lo da <br />
                        melhor maneira possível neste processo.
                    </Typography>

                    <Box sx={{ display: { xs: 'block', md: 'none' } }} padding='.56rem 0 .3rem' margin='0 auto'>
                        <Typography fontSize='.875rem' fontWeight={600} lineHeight='1.3' textAlign='center' paddingBottom='.5rem'>
                            Atendimento de Segunda à Sexta das 08h as 18h <br /> e aos Sábados das 8h às 14h
                        </Typography>
                        <Typography fontSize='.75rem' fontWeight={600} textAlign='center'>
                            (digite a opção 7)
                        </Typography>
                    </Box>

                    <Box sx={boxStyle}>
                        <Box sx={{ display: 'flex', gap: '1.43rem', flexDirection: { xs: 'column', md: 'row' } }}>
                            <LinkLabel label='São Paulo' link='tel:1136169000' number='11 3616 - 9000' />
                            <LinkLabel label='Demais Localidades' link='tel:08007742000' number='0800 774 2000' />
                        </Box>
                        <Box sx={{ display: { xs: 'none', md: 'block' } }} padding='.75rem 0 .3rem'>
                            <Typography fontSize='.875rem' fontWeight={600} lineHeight='1.3' textAlign='center' paddingBottom='.5rem'>
                                Atendimento de Segunda à Sexta das 08h as 18h <br /> e aos Sábados das 8h às 14h
                            </Typography>
                            <Typography fontSize='.75rem' fontWeight={600} textAlign='center'>
                                (digite a opção 7)
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </FadeAnimation >
    );
}

export default Cancellation;

